// import { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import decode from 'jwt-decode';
// import { REHYDRATE } from 'redux-persist/lib/constants';
// import { HOME_GET_AUTHRIZATION } from './constants';

// export function getAuthrization(auth) {
//   return {
//     type: HOME_GET_AUTHRIZATION,
//     data: auth,
//   };
// }

// export function useGetAuthrization() {
//   const dispatch = useDispatch();
//   const auth = useSelector(state => state.home.auth);

//   const updateAuthrization = useEffect(() => {
//     if (window.location.href.indexOf('id_token') > -1) {
//       let newAuth = JSON.parse(JSON.stringify(auth));
//       const idToken = window.location.href.match(/(id_token)\=([\S\s]*?)\&/)[2]; //eslint-disable-line
//       const decodeToken = decode(idToken);
//       const email = decodeToken.email;
//       const name = decodeToken['custom:networkid'];
//       const userId = name ? (name.indexOf('@') === -1 ? name : name.slice(0, name.indexOf('@'))) : null;
//       const userName = email && email.slice(0, email.indexOf('@')).split(".").map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(".");
//       const providerName = decodeToken?.identities[0]?.providerName;
//       newAuth.cognitoIdToken = idToken;
//       newAuth.validUser = true;
//       const newUserId = userId?userId:userName;
//       //COT-9006,Change the login name of SIA+ to the full name
//       let fullName = userName;
//       if(decodeToken?.identities && decodeToken?.identities[0]?.providerType === 'SAML'){
//         fullName = decodeToken?.name?.split(',')[1]+' '+decodeToken?.name?.split(',')[0];
//       }else{
//         fullName = decodeToken["cognito:username"];
//       }
//       newAuth.user = {
//         email,
//         userId:newUserId,
//         userName,
//         fullName,
//         providerName,
//       };
//       dispatch(getAuthrization(newAuth));
//     }
//   }, [dispatch, window.location.href.indexOf('id_token')]); //eslint-disable-line

//   return { auth, updateAuthrization };
// }

// export function reducer(state, action) {
//   switch (action.type) {
//     case HOME_GET_AUTHRIZATION:
//       return {
//         ...state,
//         auth: action.data,
//       };
//     case REHYDRATE:
//       const payloadData = action.payload;
//       if (payloadData) {
//         const authData = payloadData.home;
//         if(authData.auth) {
//           return {
//             ...state,
//             auth: authData.auth,
//           };
//         }
//       }
//       return state;
//     default:
//       return state;
//   }
// }



import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import decode from 'jwt-decode';
import { REHYDRATE } from 'redux-persist/lib/constants';
import { HOME_GET_AUTHRIZATION } from './constants';
import { exchangeCodeForTokens } from '../../../common/authService';

export function getAuthrization(auth) {
  return { type: HOME_GET_AUTHRIZATION, data: auth };
}

function buildAuthFromTokens(tokens) {
  const decodeToken = decode(tokens.id_token);
  const email = decodeToken.email;
  const name = decodeToken['custom:networkid'];
  const userId = name ? (name.indexOf('@') === -1 ? name : name.slice(0, name.indexOf('@'))) : null;
  const userName = email && email.slice(0, email.indexOf('@')).split('.').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join('.');
  const providerName = decodeToken?.identities?.[0]?.providerName;
  let fullName = userName;
  if (decodeToken?.identities && decodeToken?.identities[0]?.providerType === 'SAML') {
    fullName = decodeToken?.name?.split(',')[1] + ' ' + decodeToken?.name?.split(',')[0];
  } else {
    fullName = decodeToken['cognito:username'];
  }
  return {
    cognitoIdToken: tokens.id_token,
    accessToken: tokens.access_token,
    refreshToken: tokens.refresh_token,
    expiresAt: Date.now() + tokens.expires_in * 1000,
    validUser: true,
    user: { email, userId: userId || userName, userName, fullName, providerName },
  };
}

export function useGetAuthrization() {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.home.auth);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    if (code && !auth.cognitoIdToken) {
      exchangeCodeForTokens(code)
        .then(tokens => {
          dispatch(getAuthrization(buildAuthFromTokens(tokens)));
          // remove ?code=... from the URL so a refresh doesn't retry the (now-consumed) code
          window.history.replaceState({}, document.title, window.location.pathname);
        })
        .catch(() => {
          // exchange failed (e.g. code already consumed) — let App.js's redirect-to-login fallback handle it
        });
    }
  }, [dispatch, auth.cognitoIdToken]); //eslint-disable-line

  return { auth };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_GET_AUTHRIZATION:
      return { ...state, auth: action.data };
    case REHYDRATE: {
      const payloadData = action.payload;
      if (payloadData?.home?.auth) {
        return { ...state, auth: payloadData.home.auth };
      }
      return state;
    }
    default:
      return state;
  }
}


